import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questionnaire-upload-document-modal";

const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Upload Document",
        fr: "Télécharger un document",
    },
    cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    confirm: {
        en: "Confirm",
        fr: "Confirmer",
    },
});

export function useSupplierQuestionnaireUploadDocumentModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
